import React, { Fragment, useState } from 'react';
import { translate } from '../Services/translation';
import { INCREASE_QTY, DECREASE_QTY } from "../constants"


const ProductQuantity = ({
    quantityFieldId,
    packingQuantity,
    defaultQuantity
}) => {
    const [showQuantityWarning, setShowQuantityWarning] = useState(false);

    const toggleQuantityWarning = (show) => {
        setShowQuantityWarning(show || !showQuantityWarning);
    }

    const checkMultiple = (multipleQty, currentQty, el, updateType) => {
        if (currentQty === multipleQty) {
            el.value = currentQty;
        }
        else if (currentQty % multipleQty !== 0) {
            if (updateType === DECREASE_QTY) {
                let decreasedValue = Math.floor(currentQty / multipleQty) * multipleQty;
                el.value = parseFloat(decreasedValue.toFixed(1));
            }
            else if (updateType === INCREASE_QTY) {
                let increasedValue = Math.ceil(currentQty / multipleQty) * multipleQty;
                el.value = parseFloat(increasedValue.toFixed(1));
            }
            else {
                toggleQuantityWarning(true);
                let changedValue = Math.ceil(currentQty / multipleQty) * multipleQty;
                el.value = parseFloat(changedValue.toFixed(1));
                setTimeout(() => setShowQuantityWarning(false), 5000);
            }
        }
    }

    const updateValue = (quantityFieldId, packingQuantity, updateType) => {
        const el = document.getElementById(quantityFieldId);
        packingQuantity = parseFloat(packingQuantity);
        if (el) {
            let amountValue = el.value;
            let currentQty = parseFloat(amountValue).toFixed(1);
            if (updateType === INCREASE_QTY) {
                currentQty++;
            } else if (updateType === DECREASE_QTY && currentQty > 0) {
                currentQty--;
            }
            currentQty = isNaN(currentQty) || currentQty < packingQuantity ? packingQuantity : currentQty;
            if (updateType == null) {
                currentQty = isNaN(amountValue) ? packingQuantity : amountValue;
            }
            else if (currentQty >= packingQuantity) {
                el.value = currentQty;
            }
            checkMultiple(packingQuantity, currentQty, el, updateType);
        }
    }

    return (
        <Fragment>
            <div className="product__buy-quantity-wrapper">
                <div className="product__buy-quantity-decrease" onClick={() => updateValue(quantityFieldId, packingQuantity, DECREASE_QTY)}></div>
                <div className="product__buy-quantity-input-container">
                    <input id={quantityFieldId}
                        type="number"
                        data-buy-quantity-input
                        defaultValue={defaultQuantity}
                        min="1"
                        className="product__buy-quantity form__input"
                        aria-label={translate('code.productquantity.label')}
                        onBlur={() => updateValue(quantityFieldId, packingQuantity)} />
                </div>
                <div className="product__buy-quantity-increase" onClick={() => updateValue(quantityFieldId, packingQuantity, INCREASE_QTY)}></div>
            </div>
            {showQuantityWarning &&
                <div className="product-quantity--warning">{translate('code.product.quantity.changed')}</div>
            }
        </Fragment>
    );
};
export default ProductQuantity;